import api from './api';

const endpoint = '/api/v1/newslettersignup/signup';

export default {
    async add(name, emailAddress, phoneNumber) {
        return await api.post(endpoint, {
            name: name,
            phone_number: phoneNumber,
            email: emailAddress,
        });
    }
}
